import { render, staticRenderFns } from "./asignarEditarPlanConvenioPaciente.vue?vue&type=template&id=012cea35&scoped=true"
import script from "./asignarEditarPlanConvenioPaciente.vue?vue&type=script&lang=js"
export * from "./asignarEditarPlanConvenioPaciente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012cea35",
  null
  
)

export default component.exports